export default "__VITE_ASSET__D$dadph$__"